import $ from 'jquery';

export default class BaseButton {
  constructor(container) {
    this.container = container;
    this.selector = null;
    this._$btn = null;
    this.toggled = false;
    this.labelOn = null;
    this.labelOff = null;
  }

  init() {
    this.btn = $(this.selector, this.container);
    this.labelOn = this.btn.data('label-on');
    this.labelOff = this.btn.data('label-off');
  }

  focus() {
    this.btn.focus();
  }

  set btn(elt) {
    this._$btn = elt;
  }

  get btn() {
    return this._$btn;
  }

  toggle() {
    this.toggled = !this.toggled;
    if (this.labelOn && this.labelOff) {
      let label = this.labelOff;
      if(this.toggled) {
        label = this.labelOn;
      }
      this.btn
        .find('.sr-only')
        .text(label);
    }
  }

  onClick(callback) {
    this.btn.on('click', e => {
      e.preventDefault();
      this.toggle();
      if (callback) {
        callback(this);
      }
    });
  }

  destroy() {
    this.btn.off();
    this.btn=null;
    this.toggled = false;
  }


  reset() {
    this.toggled = false;
  }
}
